import { render } from "./QRCodeViewer.vue?vue&type=template&id=363c64bd&scoped=true&ts=true"
import script from "./QRCodeViewer.vue?vue&type=script&lang=ts"
export * from "./QRCodeViewer.vue?vue&type=script&lang=ts"

import "./QRCodeViewer.vue?vue&type=style&index=0&id=363c64bd&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363c64bd"]])

export default __exports__